import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () => {
  return axios.create({
    baseURL: `${config.serverUrl}`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })
}

const ticketApi = {
  getTicketTags: (request) => {
    return instance().get(`/tickets-tags`, { params: request })
  },
  getTicketTagsList: (pageId, params) => {
    return instance().get(`/page/${pageId}/ticket-tag-list`, { params })
  },
  putEditTicketTag: (request) => {
    const { data } = request
    const { pageid, ...rest } = data
    return instance().put(`page/${pageid}/edit-ticket-tag`, rest)
  },
  getExportTicket: (request) => {
    const { config } = request
    return instance().get(`/api/ticket/export-ticket`, config)
  },
  deleteTag: (request) => {
    const { data, pageid } = request
    return instance().delete(`page/${pageid}/delete-ticket-tag`, { data })
  },
  putCloseMultiSelect: (request) => {
    const { data } = request
    return instance().put(`/api/ticket/close-multi-ticket`, data)
  }
}

export default ticketApi



// WEBPACK FOOTER //
// ./src/api/ticket.js